import React, { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// Actions
import { connect } from "react-redux";
import {
  highlightSpotlightBlockEntities,
  // removeSpotlightBlockEntities,
} from "../../../../actions/MetalensActions/metalensActions";

import {
  departmentIconMapping,
  tagDescriptionMapping,
} from "../../../../constants/metalens";
import DocumentReviewProvideFeedback from "./DocumentReviewProvideFeedback";
import DocumentReviewSpotlightCard from "./DocumentReviewSpotlightCard";

const DocumentReviewClauseTag = ({
  analysis,
  setActive,
  active,
  index,
  reviewClausesActive,
  docID,
  sharingHash,
  highlightSpotlightBlockEntitiesAction,
}) => {
  const [optionMenuActive, setOptionMenuActive] = useState(false);
  const [feebackActive, setFeedbackActive] = useState(false);

  const _setActiveComponent = componentID => {
    const comp = document.getElementById(componentID);
    if (comp) {
      comp.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      if (!comp.className.includes("documentreview-highlight")) {
        comp.className += " documentreview-highlight";
      }
      // show spotlight
      highlightSpotlightBlockEntitiesAction(
        analysis.block_entities,
        componentID,
      );
    }
  };

  const _removeActiveComponent = componentID => {
    const comp = document.getElementById(componentID);
    if (comp) {
      comp.className = comp.className.replaceAll(
        "documentreview-highlight",
        "",
      );
    }
  };

  useEffect(
    () => {
      if (active && reviewClausesActive) {
        _setActiveComponent(analysis.id);
      }

      return () => {
        if (active && reviewClausesActive) {
          _removeActiveComponent(analysis.id);
        }
      };
    },
    [
      _removeActiveComponent,
      _setActiveComponent,
      active,
      analysis.id,
      reviewClausesActive,
    ],
  );

  return (
    <div
      onClick={() => {
        setActive(index);
        _setActiveComponent(analysis.id);
      }}
      tabIndex="0"
      role="button"
      onKeyDown={() => {}}
      className={`documentreviewclause-tag ${
        active ? "documentreviewclause-tag-active" : ""
      }`}>
      <div
        className={`documentreviewclause-tag-head ${
          active ? "documentreviewclause-tag-head-is-active" : ""
        }`}>
        {analysis.departments &&
          analysis.departments.map(dep => (
            <div
              className="documentreviewclause-tag-head-dep"
              key={`${analysis.id}-${dep}`}>
              <span className="documentreviewclause-tag-head-dep-icon">
                <FontAwesomeIcon
                  icon={["far", departmentIconMapping[dep] || ""]}
                  className=""
                />
              </span>
              <span>{dep.toUpperCase()}</span>
            </div>
          ))}
      </div>
      <div className="documentreviewclause-tag-body">
        {analysis.block_entities && analysis.block_entities.length ? (
          <DocumentReviewSpotlightCard
            entities={analysis.block_entities}
            active={active}
          />
        ) : null}
        {analysis.tags &&
          analysis.tags.map(item => (
            <div className="documentreviewclause-tag-body-clause-container">
              <div className="documentreviewclause-tag-body-clause">
                {item.tag}
              </div>
              {/* if active desctiption */}
              {active && (
                <div className="documentreviewclause-tag-body-clause-description">
                  {tagDescriptionMapping[item.tag] || ""}
                </div>
              )}
            </div>
          ))}
      </div>
      {!active && analysis.block_entities && analysis.block_entities.length ? (
        <div
          data-belongsto="metalens-dropdown"
          className="documentreviewclause-tag-spotlight-pill">
          <span
            data-belongsto="metalens-dropdown"
            role="img"
            aria-label="spotlight-icon"
            className="documentreview-spotlight-card-body-title-icon">
            &#128294;
          </span>
          Spotlight
        </div>
      ) : null}

      {active && (
        <div
          tabIndex="0"
          role="button"
          onKeyDown={() => {}}
          onClick={e => {
            e.preventDefault();
            setOptionMenuActive(!optionMenuActive);
          }}
          className="documentreviewclause-tag-option-container">
          <div className="documentreviewclause-tag-option">
            <span>
              <FontAwesomeIcon icon={["far", "ellipsis-v"]} className="" />
            </span>
            {optionMenuActive && (
              <div
                tabIndex="0"
                role="button"
                onKeyDown={() => {}}
                onClick={e => {
                  e.stopPropagation();
                  setFeedbackActive(true);
                  setOptionMenuActive(!optionMenuActive);
                }}
                data-belongsto="metalens-dropdown"
                className="documentreviewclause-tag-option-menu">
                <span
                  data-belongsto="metalens-dropdown"
                  className="documentreviewclause-tag-option-menu-icon">
                  <FontAwesomeIcon icon={["far", "comments"]} className="" />
                </span>
                Provide Feedback
              </div>
            )}
          </div>
          {/*  */}
          <DocumentReviewProvideFeedback
            show={feebackActive}
            onClose={event => {
              if (event && event.nativeEvent) {
                event.nativeEvent.stopImmediatePropagation();
              }
              setFeedbackActive(false);
            }}
            componentID={analysis.id}
            docID={docID}
            sharingHash={sharingHash}
          />
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = {
  highlightSpotlightBlockEntitiesAction: highlightSpotlightBlockEntities,
  // removeSpotlightBlockEntitiesAction: removeSpotlightBlockEntities,
};

export default connect(
  null,
  mapDispatchToProps,
)(DocumentReviewClauseTag);



// WEBPACK FOOTER //
// ./src/components/QuickReview/DocumentReviewSection/DocumentReviewClauses/DocumentReviewClauseTag.js